__turbopack_context__.v({
  "ambientGlow": "HeroLogoShowcase-module__QYOxTa__ambientGlow",
  "cardinalDiamond": "HeroLogoShowcase-module__QYOxTa__cardinalDiamond",
  "counterRotatingGroup": "HeroLogoShowcase-module__QYOxTa__counterRotatingGroup",
  "curvedText": "HeroLogoShowcase-module__QYOxTa__curvedText",
  "dashedRing": "HeroLogoShowcase-module__QYOxTa__dashedRing",
  "emberParticle": "HeroLogoShowcase-module__QYOxTa__emberParticle",
  "floatEmber": "HeroLogoShowcase-module__QYOxTa__floatEmber",
  "logoImage": "HeroLogoShowcase-module__QYOxTa__logoImage",
  "logoWrapper": "HeroLogoShowcase-module__QYOxTa__logoWrapper",
  "outerRing": "HeroLogoShowcase-module__QYOxTa__outerRing",
  "pedestal": "HeroLogoShowcase-module__QYOxTa__pedestal",
  "pedestalInnerBorder": "HeroLogoShowcase-module__QYOxTa__pedestalInnerBorder",
  "pedestalInnerRing": "HeroLogoShowcase-module__QYOxTa__pedestalInnerRing",
  "rotateClockwise": "HeroLogoShowcase-module__QYOxTa__rotateClockwise",
  "rotateCounterClockwise": "HeroLogoShowcase-module__QYOxTa__rotateCounterClockwise",
  "rotatingGroup": "HeroLogoShowcase-module__QYOxTa__rotatingGroup",
  "showcaseWrapper": "HeroLogoShowcase-module__QYOxTa__showcaseWrapper",
  "specularSheen": "HeroLogoShowcase-module__QYOxTa__specularSheen",
  "stage3D": "HeroLogoShowcase-module__QYOxTa__stage3D",
  "svgContainer": "HeroLogoShowcase-module__QYOxTa__svgContainer",
  "tickLine": "HeroLogoShowcase-module__QYOxTa__tickLine",
  "tickLineMajor": "HeroLogoShowcase-module__QYOxTa__tickLineMajor",
});
